import Page from 'components/Page';
import * as React from 'react';
import { Spinner } from 'components/Spinner';
const AttorneySignUpPage = React.lazy(() => import(/* webpackChunkName: "AttorneySignUp" */ './Page'));
export const AttorneySignUp = () => (React.createElement(Page, { title: "Attorney Signup", description: "Attorney Signup for new account.", keywords: "Attorney Signup , Attorney , Signup Attorney" },
    React.createElement(React.Suspense, { fallback: React.createElement(Spinner, null) },
        React.createElement(AttorneySignUpPage, null))));
